<script lang="ts" setup>
import { computed, type PropType } from 'vue';
import { FormElement } from '@common';
import { useLoadHtmlContent } from '@shared';

const props = defineProps({
  element: {
    type: Object as PropType<FormElement>,
    required: true
  }
});

const key = computed(() => String(props.element.attributes.label ?? ''));

const { htmlContent } = useLoadHtmlContent(key.value);
</script>

<template>
  <div
    v-if="htmlContent?.html"
    v-html="htmlContent.html"></div>
</template>
